/**
 * Simple validator that checks value is a valid name. Note that this only
 * validates English names. Non-English names will fail validation.
 * @param value String to check if it's a valid name.
 * @returns Whether or not value is a valid English name.
 */
export function isValidName(value) {
  // Simple regex to check if it's a valid name. See https://stackoverflow.com/a/2385967
  const reg = /^[a-z ,.'-]+$/i;
  return reg.test(value);
}

/**
 * Returns whether the name is a full name.
 * @param name Name string that includes first and last name. This method
 *     assumes the argument is a valid name.
 * @returns Whether it's a full name.
 */
export function isFullName(name) {
  const nameArr = name.split(' ');
  return nameArr.length > 1;
}

/**
 * Returns the first name from a name string.
 * @param name Name string that includes first name. This method assumes the
 *     argument is a valid name.
 * @returns First name.
 */
export function getFirstName(name) {
  return name.split(' ')[0];
}

/**
 * Returns the last name from a name string.
 * @param name Name string that includes last name. This method assumes the
 *     argument is a valid name.
 * @returns Last name.
 */
export function getLastName(name) {
  const nameArr = name.split(' ');
  return nameArr[nameArr.length - 1];
}
